<template>
    <div class="right_icons_box"> 
        <!-- md  -->
        <div class="md_box" @click="openmd">
            <div class="font_line">关</div>
            <div class="font_line">注</div>
            <div class="font_line">我</div>
            <div class="font_line">们</div>
        </div>
        <!-- pc -->
        <div class="right_icons one" style="margin:4px;margin-bottom: 8px;" @click="backtopBtn">
            <div class="button_img_box"></div>
            <div  class="right_wenzi">返回顶部</div>
        </div>
        <el-tooltip 
            class="item" 
            effect="light" 
            placement="left">
            <div slot="content" style="font-size: 16px;">
                <img src="../assets/icons/官网首页_slices/erweima.png" style="width: 96px; height: 96px" alt="">
                <!-- <div style="display: flex;justify-content: center;align-items: center;">
                    <img src="../assets/icons/官网首页_slices/微信二维码.png" style="width: 40px;height: 40px;margin-right: 10px;" alt="" srcset="">
                    <div style="padding-right: 30px;">
                        <div style="font-size: 16px; font-weight: 700;">关注微信公众号</div>
                        <div style="font-size: 14px; font-weight: 500;margin-top: 5px;">获取最新分享内容</div>
                    </div>
                </div>
                <div style="text-align: center;margin-bottom: 10px;margin-top: 5px;">
                    <img :src="compony.qrCode" style="width: 140px;height: 140px;" alt="" srcset="">
                    <div>
                        <span>微信扫一扫关注</span>
                        <div style="margin-top: 5px;">或搜索关注：<span style="color: #2483C6;font-weight: bold;">宜联科技</span></div>
                    </div>
                </div> -->
            </div>
            <div class="right_icons two">
                <div class="button_img_box"></div>
                <div class="right_wenzi" style="left: 14%;">官方微信</div>
            </div>
        </el-tooltip>
        <el-tooltip class="item" effect="light" content="Left Top 提示文字" placement="left">
            <div slot="content" style="padding: 20px 10px;font-size: 16px;">电话咨询：17354516359</div>
            <div class="right_icons three">
                <div class="button_img_box"></div>
                <div class="right_wenzi">在线咨询</div>
            </div>
        </el-tooltip>
       <el-dialog
            append-to-body
            :show-close="false"
            :visible.sync="dialogVisible"
            width="70%">
            <div class="contact_box">
                <div class="contact_content">
                    <div class="contact_title">公司二维码</div>
                    <img class="contact_img" src="../assets/icons/官网首页_slices/erweima.png" alt="">
                </div>
                 <div class="contact_content">
                    <div class="contact_phone_title">公司联系电话</div>
                    <div class="contact_phone">173-5451-6359</div>
                </div>
            </div>
            <div class="close_box" @click="closemd">
               <img src="../assets/icons/官网首页_slices/close.png" alt=""> 
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            compony:{},
            dialogVisible:false,
        }
    },
    methods:{
        openmd(){
            this.dialogVisible=true;
        },
        closemd(){
            this.dialogVisible=false;
        },
        backtopBtn() {
            var timer = setInterval(function () {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop /5);
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if ( osTop == 0) { 
                    // alert("已经到50了")    
                    clearInterval(timer)    
                }
            }, 5);
            // document.documentElement.scrollTop = 0;
        }
    },
}
</script>
<style lang="less" scoped>
/* 手机设备 */ 
@media(max-width:730px){ 
    /deep/.el-dialog__header {
        padding:0px 0px;
    }
    /deep/.el-dialog__body{
        position: relative;
        .close_box{
            width: 32px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 50%;
            position: absolute;
            bottom: -15%;
            left: 45%;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width: 12px;    
                height: 12px;
            }
        }
    }
    .contact_box{
        .contact_content{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .contact_phone{
                font-weight: 500;
                font-size: 21px;
                color: #027DFC;
            }
            .contact_phone_title{
                font-weight: 400;
                font-size: 16px;
                color: #606060;
                margin-bottom: 5px;
                margin-top: 20px;
            }
            .contact_title{
                font-weight: 400;
                font-size: 16px;
                color: #606060;
                margin-bottom: 5px;
            }
            .contact_img{
                width: 158px;
                height: 158px;
            }
        }
    }
    .right_icons_box{
        .md_box{
            writing-mode: vertical-rl;
            text-orientation: upright;
            display: flex;
            justify-content: space-around; 
            box-sizing: border-box;
            padding: 14px 0px;
            align-items: center;
            height: 100px; 
            width: 25px;
            background: #027DFC;
            border-top-left-radius: 12px;
            border-bottom-left-radius: 12px;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            // .font_line{
            //     // height: 10px;
            // }
        }
        .right_icons{
            display: none;
        }
        position: fixed;
        z-index: 8;
        top: 250px;
        right: 0px;
        // border-top-left-radius: 12px;
        // border-bottom-left-radius: 12px;
        // border-top: 5px solid black;
        // border-left: 5px solid black;
        // border-bottom: 5px solid black;
    }
}
// @media(min-aspect-ratio: 0.4) and (max-aspect-ratio: 1) and (min-width:1080px) {
//     /deep/.el-dialog__header {
//         padding:0px 0px;
//     }
//     /deep/.el-dialog__body{
//         position: relative;
//         .close_box{
//             width: 70px;
//             height: 70px;
//             background: #FFFFFF;
//             border-radius: 50%;
//             position: absolute;
//             bottom: -15%;
//             left: 45%;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             img{
//                 width: 28px;    
//                 height: 28px;
//             }
//         }
//     }
//     .contact_box{
//         .contact_content{
//             width: 100%;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             flex-direction: column;
//             .contact_phone{
//                 font-weight: 500;
//                 font-size: 36px;
//                 color: #027DFC;
//                 margin-bottom: 50px;
//             }
//             .contact_phone_title{
//                 font-weight: 400;
//                 font-size: 36px;
//                 color: #606060;
//                 margin-bottom: 20px;
//                 margin-top: 40px;
//             }
//             .contact_title{
//                 font-weight: 400;
//                 font-size: 36px;
//                 color: #606060;
//                 margin-top: 40px;
//                 margin-bottom: 20px;
//             }
//             .contact_img{
//                 width: 350px;
//                 height: 350px;
//             }
//         }
//     }
//     .right_icons_box{   
//         position: fixed;
//         z-index: 8;
//         top: 590px;
//         right: 0px;
//         .md_box{
//             writing-mode: vertical-rl;
//             text-orientation: upright;
//             display: flex;
//             justify-content: space-around; 
//             box-sizing: border-box;
//             padding: 23px 0px;
//             align-items: center;
//             height: 170px; 
//             width: 45px;
//             background: #027DFC;
//             border-top-left-radius: 22px;
//             border-bottom-left-radius: 22px;
//             font-size: 20px;
//             font-weight: 400;
//             color: #FFFFFF;
//             // .font_line{
//             //     // height: 10px;
//             // }
//         }
//         .right_icons{
//             display: none;
//         }
     
//         // border-top-left-radius: 12px;
//         // border-bottom-left-radius: 12px;
//         // border-top: 5px solid black;
//         // border-left: 5px solid black;
//         // border-bottom: 5px solid black;
//     }
// }
/* pc设备 */
@media  (min-width:730px){

    .right_icons_box{
        box-sizing: border-box;
        position: fixed;
        top: 650px;
        right: 40px;
        z-index: 9;
        .md_box{
            display: none;
        }
        .item {
            margin: 4px;
        }
        .one{
            .button_img_box{
                width: 32px;
                height: 32px;
                background: url('../assets/icons/官网首页_slices/return.png') no-repeat;
            }
        }
        .one:hover{
            .button_img_box{
                width: 32px;
                height: 32px;
                background:url('../assets//icons/官网首页_slices/returnsel.png')
            }
        }
        .two{
            .button_img_box{
                width: 32px;
                height: 32px;
                background: url('../assets/icons/官网首页_slices/wechat.png') no-repeat;
            }
        }
        .two:hover{
            .button_img_box{
                width: 32px;
                height: 32px;
                background:url('../assets//icons/官网首页_slices/wechatsel.png')
            }
        }
        .three{
            .button_img_box{
                width: 32px;
                height: 32px;
                background: url('../assets/icons/官网首页_slices/phone.png') no-repeat;
            }
        }
        .three:hover{
            .button_img_box{
                width: 32px;
                height: 32px;
                background:url('../assets//icons/官网首页_slices/phonesel.png')
            }
        }
        .right_icons:hover{
        
            .right_wenzi{
                color: #027DFC;

            }
        }
        .right_icons{
            width: 72px !important;
            height: 72px !important;
            background: #FFFFFF;
            box-shadow: 0px 0px 8px 0px rgba(96,96,96,0.2);
            border-radius: 4px;
            margin-bottom: 8px;
            left: 95%;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .img_box{
                width: 32px;
                height: 32px;
            }
            .right_wenzi{
                font-size: 12px;
                font-family: Source Han Sans CN VF;
                font-weight: 400;
                color: #909090;
                margin-top: 5px;
            }
        }
    }
}
</style>